import React, {useEffect, useState} from 'react';
import { useDispatch } from 'react-redux';
import {alertService} from '@app/services/alertService';

import {myService} from '@app/services/donhangService';
import * as mainService from '@app/services/mainService';
import {useLocation} from 'react-router-dom';
import {getControllerName, getDefaultSelectValue} from '@app/utils/helpers';
import HeaderClick from '@app/utils/HeaderClick';
import {checkRole, createObj, updateObj} from '@app/services/mainService';
import {Button, Modal} from "react-bootstrap";

import {
    image_root  , INIT_ROLE_MENU
} from "@app/const/AppSetting";

import {useTranslation} from "react-i18next";
import {ClipLoader} from "react-spinners";
import NhanvienListComponent from '@pages/FUtil/NhanvienListComponent';
import KhachhangListComponent from '@pages/FUtil/KhachhangListComponent';
import NewDatePicker from "@pages/FUtil/NewDatePicker";
import DateTimePicker from "@pages/FUtil/DateTimePicker";
import SanphamAutocompleteComponent from "@pages/FUtil/SanphamAutocompleteComponent";
import {checkIfIdExists} from "@app/utils/CommonFunctions";
import RanglienketComponent from "@pages/FUtil/RanglienketComponent";
import ColorListComponent from "@pages/FUtil/ColorListComponent";
import NhomnhanvienListComponent from "@pages/FUtil/NhomnhanvienListComponent";
import LoaidonhangListComponent from "@pages/FUtil/LoaidonhangListComponent";
import {HRTag} from "@components";
import TrangthaiListComponent from "@pages/FUtil/TrangthaiListComponent";
import GuikemListComponent from "@pages/FUtil/GuikemListComponent";

function DonhangEdit({history, match}) {
    const [t] = useTranslation();
    const location = useLocation();
    const dispatch = useDispatch();
    const [showModal, setShowModal] = useState(false);
    const [sanphamModal, setSanphamModal] = useState(false);
    const [sanphamModalIndex, setSanphamModalIndex] = useState(false);
    const currController = getControllerName(location.pathname);
    const [loading, setLoading] = useState(false);
  
    let {id} = match.params;
    let isAddMode = !id;
    const isDisplay = id && location.pathname.indexOf(`view`) > 0;
    const [handleToogle, setHandleToogle] = useState(false);

    const [hasRole, setHasRole] = useState(false);
    const [roleMenu, setRoleMenu] = useState(INIT_ROLE_MENU);

    const initial = {
        id: id || 0,
        ranglienket1_fk:null,
        ranglienket2_fk:null,
        tong_so_rang:'',

        ma:'',
        ngay : new Date().toISOString().split('T')[0],
        ngay_nhan :'',
        ngay_giao :'',
        benh_nhan:'',
        khachhang_fk:null,
        nha_sy:'',
        color_fks:[],
        nhanvien1_fk:null,
        nhanvien2_fk:null,
        nhanvien3_fk:null,
        nhanvien4_fk:null,
        nhanvien5_fk:null,
        nhanvien6_fk:null,
        nhanvien7_fk:null,
        nhanvien8_fk:null,
       // chi_dinh:'',
        ghi_chu:'',
        sanpham:[],
        trangthai_fk:0
    };

    const getStatusInfo = (status) => {
        switch (status) {
            case 0:
                return { text: "Đang xử lý", className: "bg-secondary text-white" };
            case 1:
                return { text: "Đang xử lý cad/cam", className: "bg-info text-white" };
            case 2:
                return { text: "Đang xử lý cưa đai", className: "bg-primary text-white" };
            case 3:
                return { text: "Đang xử lý sáp", className: "bg-primary text-white" };
            case 4:
                return { text: "Đang xử lý đắp", className: "bg-primary text-white" };
            case 5:
                return { text: "Đang xử lý mài", className: "bg-primary text-white" };
            case 6:
                return { text: "Đã gửi KH - Đang giao", className: "bg-primary text-white" };
            case 7:
                return { text: "KH đã nhận (hoàn tất)", className: "bg-success text-white" };
            case 8:
                return { text: "Đã hủy/đóng đơn", className: "bg-light text-dark" };
            case 9:
                return { text: "Đang xử lý sườn", className: "bg-primary text-white" };
            default:
                return { text: "Không xác định", className: "bg-light text-dark" };
        }
    };

    const getStatusFilter_New = (status) => {
        switch (status) {
            case 0: return [0, 1, 2];
            case 1: return [0, 1, 2];
            case 2: return [0, 1, 2, 3];
            case 3: return [0, 2, 3, 9];
            case 4: return [0, 3, 4, 5];
            case 5: return [0, 4, 5, 6];
            case 6: return [6,7];
            case 9: return [0, 3, 9, 4];
            default: return [0, 1]; // fallback
        }
    };

    const getStatusFilter_DifNew = (status) => {
        switch (status) {
            case 0: return [0, 1, 2, 3, 4, 5, 9];
            case 1: return [0, 1, 2];
            case 2: return [0, 1, 2, 3];
            case 3: return [0, 2, 3, 9];
            case 4: return [0, 3, 4, 5];
            case 5: return [0, 4, 5, 6];
            case 6: return [6,7];
            case 9: return [0, 3, 9, 4];
            default: return [0, 1]; // fallback
        }
    };

    const [obj, setObj] = useState({...initial});
    const [obj1, setObj1] = useState({...initial});
    const statusInfo = getStatusInfo(obj1.trangthai_fk);
    //const statusInfo = obj1.trang_thai;
    const [filterTrangthais,setfilterTrangthais] = useState([]);

    const onChangeInput =  (e) => {
        const {name, value, checked} = e.target;

        if(name ==="sanpham") {
            console.log(value);
            if(checkIfIdExists(obj.sanpham,value.id))
            {
                alert('Sản phẩm đã tồn tại trong đơn hàng');
                return;
            }

            const newItem = { ...value, so_luong: 0,thanh_tien: 0, chi_dinh: value.ten }

            setObj((prevState) => ({
                ...prevState,
                sanpham: [...prevState.sanpham, newItem]
            }));
        }else if(name ==='ranglienket1_fk')
        {
            setObj((prevState) => ({
                ...prevState,
                [name]: value,
                ranglienket2_fk: null,
                tong_so_rang: value? 1 : 0
            }));
        } else if(name ==='ranglienket2_fk')
        {
            let mtong_so_rang = 0;
            if(value)
            {
                if(Number(obj.ranglienket1_fk.phan_tu) === Number(value.phan_tu))
                    mtong_so_rang =  Number(value.stt) - Number(obj.ranglienket1_fk.stt) + 1;
                else
                    mtong_so_rang = Number(value.stt) + Number(obj.ranglienket1_fk.stt);

            }
            else
            if(obj.ranglienket1_fk)
                mtong_so_rang = 1;

            setObj((prevState) => ({
                ...prevState,
                [name]: value,
                tong_so_rang: mtong_so_rang
            }));
        }
        else
        {
            setObj((prevState) => ({
                ...prevState,
                [name]: value
            }));
        }

        setHandleToogle((prevSelected) => {
            return !prevSelected;
        });

    };
   
    const createRs = async () => {

        if (!hasRole) {
            const role = await mainService.getRoleMENU(location.pathname);
            setRoleMenu(role);
            setHasRole(true);
        }

        if (!isAddMode) {
            myService.getById(id).then((response) => {
                //console.log('getById', JSON.stringify(response, null, 2));

                if(!response || !response.data || !response.data.data)    
                {
                    history.push('/'+currController);
                    alertService.error('Thông tin theo Id không tồn tại hoặc không thuộc quyền của bạn');
                }

                let userX = response.data.data;
                setObj(userX);
                setObj1(userX);

                if(userX.loaidonhang_fk === 1){
                    const filter = getStatusFilter_New(userX.trangthai_fk);
                    setfilterTrangthais(filter);
                }
                else{
                    const filter = getStatusFilter_DifNew(userX.trangthai_fk);
                    setfilterTrangthais(filter);
                }

            });
        }

    };

    useEffect(async () => {
       
         await checkRole({
                    pathname: location.pathname,
                    isAddMode,
                    currController,
                    history
                });

        await createRs();
        console.log('filter effect'+ filterTrangthais);
    }, []);

    const checkIfRangExists = (sp,items) => {
        if(items)
        {
            for(let i = 0; i < items.length; i++ )
            {
               // console.log(sp);
               // console.log(items[i]);

                console.log(sp.list_rang);
                console.log(items[i].list_rang);

                const x = sp.list_rang;
                const y  = items[i].list_rang;
                const intersection = x.filter((itemX) =>
                    y.some((itemY) => itemX.phan_tu === itemY.phan_tu && itemX.stt === itemY.stt)
                );
                if(intersection&&intersection.length > 0)
                {
                    console.log(intersection);
                    return items[i];
                }

            }
        }
        return undefined;
    };
    const getRang =   (ranglienket1_fk,ranglienket2_fk ) => {
        let list_rang = [] ;
        if(!ranglienket2_fk)
        {
            list_rang = [...list_rang, { phan_tu:ranglienket1_fk.phan_tu, stt: ranglienket1_fk.stt }]
            return list_rang;
        }
        if(Number(ranglienket1_fk.phan_tu) === Number(ranglienket2_fk.phan_tu))
        {
            for( let i = ranglienket1_fk.stt; i <= ranglienket2_fk.stt; i++ )
            {
                list_rang = [...list_rang, { phan_tu:ranglienket1_fk.phan_tu, stt: i }]
            }
            return list_rang;
        }
        for( let i = 1; i <= ranglienket1_fk.stt; i++ )
        {
            list_rang = [...list_rang, { phan_tu:ranglienket1_fk.phan_tu, stt: i }]
        }
        for( let i = 1; i <= ranglienket2_fk.stt; i++ )
        {
            list_rang = [...list_rang, { phan_tu:ranglienket2_fk.phan_tu, stt: i }]
        }
        return list_rang;

    }

    const addRang = async () => {

        if(!obj.tong_so_rang || Number(obj.tong_so_rang)<=0)
        {
            alert('Vui lòng chọn ít nhất 1 răng');
            return;
        }

        let labelname = '';
        if(obj.ranglienket2_fk)
        {
            labelname = obj.ranglienket1_fk.label +' -> ' + obj.ranglienket2_fk.label
        }
        else
            labelname = obj.ranglienket1_fk.label

        const newItem = { ranglienket1_fk:obj.ranglienket1_fk
            ,ranglienket2_fk:obj.ranglienket2_fk
            ,so_luong: obj.tong_so_rang
            ,list_rang: getRang(obj.ranglienket1_fk,obj.ranglienket2_fk)
            ,labelname:labelname
        };
        const rang_trung = checkIfRangExists(newItem,sanphamModal?.ranglienket_fks || []);
        if(rang_trung)
        {
            alert('Răng hiện tại trùng với răng ' + rang_trung.labelname);
            return;
        }
        const list = [...(sanphamModal?.ranglienket_fks || []), newItem]
        const sumRang = sumSoRang(list);
        const chi_dinh = list.map((obj) => obj.labelname).join(", ");

        const tmpSpModal = sanphamModal;
        tmpSpModal.ranglienket_fks=list;
        tmpSpModal.so_luong= sumRang;
        tmpSpModal.chi_dinh=chi_dinh;
        setSanphamModal(tmpSpModal);
        // setSanphamModal((prevState) => ({
        //     ...prevState,
        //     ranglienket_fks: list,
        //     so_luong: sumRang,
        //     chi_dinh:chi_dinh
        // }));

        let tmpsp = obj.sanpham;
        tmpsp[sanphamModalIndex]= tmpSpModal;
        setObj((prevState) => ({
            ...prevState,
            sanpham: tmpsp,
            ranglienket1_fk: null,
            ranglienket2_fk: null,
            tong_so_rang: 0
        }));
    }
    const deleterang = (rowIndex) => {
        const list = sanphamModal.ranglienket_fks.filter( (_, index) => index !== rowIndex);
        const sumR = sumSoRang(list);
        const chi_dinh = list.map((obj) => obj.labelname).join(", ");

        const tmpSpModal = sanphamModal;
        tmpSpModal.ranglienket_fks=list;
        tmpSpModal.so_luong= sumR;
        tmpSpModal.chi_dinh=chi_dinh;
        setSanphamModal(tmpSpModal);
        // setSanphamModal((prevState) => ({
        //     ...prevState,
        //     ranglienket_fks:list,
        //     so_luong: sumR,
        //     chi_dinh:chi_dinh
        // }));

        let tmpsp = obj.sanpham;
        tmpsp[sanphamModalIndex]= tmpSpModal;
        setObj((prevState) => ({
            ...prevState,
            sanpham: tmpsp,
            ranglienket1_fk: null,
            ranglienket2_fk: null,
            tong_so_rang: 0
        }));

    };
    const sumSoRang = (ranglienket_fks) =>{
        return  ranglienket_fks.reduce((sum, item) => sum + item.so_luong, 0);
    }

    const saveClick = async () => {
        let data = obj;
        if(!data)
        {
            alert('Không xác định được trang vui lòng tải lại');
            return;
        }

        // Xác nhận trước khi cập nhật
        if (!isAddMode && ((obj.trangthai_fk > obj1.trangthai_fk)||(obj.trangthai_fk===4 && obj1.trangthai_fk===9))) {
            const confirmed = window.confirm('Bạn kiểm tra lại danh mục Gửi kèm trước khi chuyển lên bộ phận tiếp theo?');
            if (!confirmed) return;
        }

         isAddMode ?  createUser(data) : update(data);

    };

    const backBrowse = () => {
        history.push('/'+currController);
    };

    async function createUser(data) {
        setLoading(true);
        // delete data.ma;
        const result = await myService.Create(data);
        if (result.status ==="1") {
            //console.log('create response', JSON.stringify(result, null, 2));
            alertService.success(result.msg);
            history.push('/'+currController);

        } else {
            alertService.error(result.msg);
        }
        setLoading(false);
    }
    async function update(data) {
        setLoading(true);
      
        const result = await myService.Update(id,data);
        if (result.status ==="1") {
            alertService.success(result.msg);
            //setfilterTrangthais(data.trangthai_fk);
            //await createRs();
            history.push('/'+currController);
            //history.push('/'+currController+'/edit/'+id);
        } else {
            alertService.error(result.msg);
        }
        setLoading(false);
    }


    if (loading) {
        return (
            <div className="flex justify-center items-center h-40">
                <ClipLoader color="#3498db" size={50} />
            </div>
        );
    }

   

    let htmlButtonSave = '';

    if(isDisplay <= 0 || (isAddMode > 0 )){
        htmlButtonSave = (
        <Button
            className="btn  btn-success  mr-1"
            
            icon="right fas fa-angle-left"
                onClick={saveClick}
                 >
                <i className="fa fa-save"> {isAddMode>0 ? "Tạo mới" :"Cập nhật"  } </i>
         </Button>   
        );
    }
    const deletesanpham = (rowIndex) => {
        setObj((prevState) => ({
            ...prevState,
            sanpham: prevState.sanpham.filter( (_, index) => index !== rowIndex)
        }));

    };
    const openRanglienket = (sp,index) => {
        setShowModal(true);
        setSanphamModal({...sp})
        setSanphamModalIndex(index)
        setObj((prevState) => ({
            ...prevState,
            ranglienket1_fk: null,
            ranglienket2_fk: null,
            tong_so_rang: 0
        }));

    };
    const handleChange_Soluong = (index, value) => {
        const updatedItems = [...obj.sanpham];
        updatedItems[index].so_luong = value;
        setObj((prevState) => ({
            ...prevState,
            sanpham: updatedItems
        }));
    };
    // eslint-disable-next-line no-shadow
    return (

        <div className="card card-primary">
            <HeaderClick
                headerName={roleMenu.tenmenu}
                isAddMode={isAddMode}
                isDisplay={isDisplay}
                history={history}
                currController={currController}
            />
            <div className="card-body">
                <div className="d-flex justify-content-between align-items-center p-2">
                    <div className="form-row">
                        <Button className="btn btn-secondary mr-1" onClick={() => backBrowse()}>
                            <i className="fa fa-arrow-circle-left"> {t('action.label.back')}</i>
                        </Button>
                        {htmlButtonSave}
                    </div>
                    { !isAddMode && (
                        <div className={`card ${statusInfo.className} mb-3`} style={{ minWidth: '150px', maxHeight: '60px' }}>
                            <div className="card-body p-2 d-flex align-items-center justify-content-center">
                                <strong>Trạng thái: {statusInfo.text}</strong>
                            </div>
                        </div>
                    )}

                </div>

                <div className="form-row p-2">
                </div>
                <div className="tab-pane fade show active" label="Thông tin bán hàng" id="thongtinnhanvien">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-3">
                                <LoaidonhangListComponent
                                    disable={obj1.trangthai_fk != 0}
                                    loaidonhang_fk = {obj.loaidonhang_fk} onChange ={(opt, e) => {
                                    const target = {name: "loaidonhang_fk", value: opt?.value};
                                    onChangeInput({target});

                                }} />
                            </div>
                            <div className="col-md-3">
                                <label>Mã đơn hàng</label>
                                <input
                                    disabled={true}
                                    type='text'
                                    className="form-control"
                                    name="ma"
                                    id ="ma"
                                    value={obj.ma}
                                />
                            </div>
                            <div className="col-md-3">
                                <label className="required">Ngày đơn hàng</label>
                                <NewDatePicker  readOnly={obj1.trangthai_fk != 0} className="form-control w-100" isV2 id="ngay" name="ngay" value={obj.ngay} onDayChange={onChangeInput} />
                            </div>
                            {/*<div className="col-md-3">
                                <label >Ngày nhận</label>
                                <NewDatePicker className="form-control w-100" isV2 id="ngay_nhan" name="ngay_nhan" value={obj.ngay_nhan} onDayChange={onChangeInput} />
                            </div>*/}
                            <div className="col-md-3">
                                <label >Ngày giao</label>
                                <DateTimePicker readOnly={!(obj1.trangthai_fk === 6 || obj1.trangthai_fk === 5)} className="form-control w-100" isV2 id="ngay_giao" name="ngay_giao" value={obj.ngay_giao} onDayChange={onChangeInput} />
                            </div>
                            <div className="col-md-3">
                                <KhachhangListComponent disable={obj1.trangthai_fk != 0} required="required" name='khachhang_fk' labelName='Nha khoa' value={obj.khachhang_fk} onChange={(opt) => onChangeInput({ target: { name: "khachhang_fk", value: opt?.value } })} />
                            </div>
                            <div className="col-md-3">
                                <label>Nha sĩ</label>
                                <input
                                    disabled={obj1.trangthai_fk != 0}
                                    type='text'
                                    className="form-control"
                                    name="nha_sy"
                                    id ="nha_sy"
                                    value={obj.nha_sy}
                                    onChange={(e) => onChangeInput( e)}
                                />
                            </div>
                            <div className="col-md-3">
                                <label>Bệnh nhân</label>
                                <input
                                    disabled={obj1.trangthai_fk != 0}
                                    type='text'
                                    className="form-control"
                                    name="benh_nhan"
                                    id ="benh_nhan"
                                    value={obj.benh_nhan}
                                    onChange={(e) => onChangeInput( e)}
                                />
                            </div>
                            <div className="col-md-3">
                                <ColorListComponent  disable={obj1.trangthai_fk != 0}
                                                    name='color_fks'
                                                     labelName='Màu'
                                                     isMulti ={true}
                                                     value={obj.color_fks}
                                                     onChange={(opt) => onChangeInput({ target: { name: "color_fks", value: opt } })} />
                            </div>
                            <div className="col-md-3">
                                <NhanvienListComponent disable={!(isAddMode === 1 || (isAddMode !== 1 && obj1.trangthai_fk === 0))} nhomnhanvien_fk={1} name='nhanvien1_fk' labelName='Nhân viên điều phối' value={obj.nhanvien1_fk} onChange={(opt) => onChangeInput({ target: { name: "nhanvien1_fk", value: opt?.value } })} />
                            </div>
                            <div className="col-md-3">
                                <NhanvienListComponent disable={!((isAddMode !== 1 && obj1.trangthai_fk === 1))} nhomnhanvien_fk={2} name='nhanvien2_fk' labelName='Nhân viên cad/cam' value={obj.nhanvien2_fk} onChange={(opt) => onChangeInput({ target: { name: "nhanvien2_fk", value: opt?.value } })} />
                            </div>
                            <div className="col-md-3">
                                <NhanvienListComponent disable={!((isAddMode !== 1 && obj1.trangthai_fk === 2))} nhomnhanvien_fk={3} name='nhanvien3_fk' labelName='Nhân viên cưa đai' value={obj.nhanvien3_fk} onChange={(opt) => onChangeInput({ target: { name: "nhanvien3_fk", value: opt?.value } })} />
                            </div>
                            <div className="col-md-3">
                                <NhanvienListComponent disable={!((isAddMode !== 1 && obj1.trangthai_fk === 3))} nhomnhanvien_fk={4} name='nhanvien4_fk' labelName='Nhân viên sáp' value={obj.nhanvien4_fk} onChange={(opt) => onChangeInput({ target: { name: "nhanvien4_fk", value: opt?.value } })} />
                            </div>
                            <div className="col-md-3">
                                <NhanvienListComponent disable={!((isAddMode !== 1 && obj1.trangthai_fk === 9))} nhomnhanvien_fk={8} name='nhanvien8_fk' labelName='Nhân viên sườn' value={obj.nhanvien8_fk} onChange={(opt) => onChangeInput({ target: { name: "nhanvien8_fk", value: opt?.value } })} />
                            </div>
                            <div className="col-md-3">
                                <NhanvienListComponent disable={!((isAddMode !== 1 && obj1.trangthai_fk === 4))} nhomnhanvien_fk={5} name='nhanvien5_fk' labelName='Nhân viên đắp' value={obj.nhanvien5_fk} onChange={(opt) => onChangeInput({ target: { name: "nhanvien5_fk", value: opt?.value } })} />
                            </div>
                            <div className="col-md-3">
                                <NhanvienListComponent disable={!((isAddMode !== 1 && obj1.trangthai_fk === 5))} nhomnhanvien_fk={6} name='nhanvien6_fk' labelName='Nhân viên mài' value={obj.nhanvien6_fk} onChange={(opt) => onChangeInput({ target: { name: "nhanvien6_fk", value: opt?.value } })} />
                            </div>
                            <div className="col-md-3">
                                <NhanvienListComponent disable={!((isAddMode !== 1 && obj1.trangthai_fk === 6))} nhomnhanvien_fk={7} name='nhanvien7_fk' labelName='Nhân viên giao hàng' value={obj.nhanvien7_fk} onChange={(opt) => onChangeInput({ target: { name: "nhanvien7_fk", value: opt?.value } })} />
                            </div>


                            <div className="col-md-3">
                                <label>Ghi chú</label>
                                <input
                                    /*disabled={obj1.trangthai_fk != 0}*/
                                    type='text'
                                    className="form-control"
                                    name="ghi_chu"
                                    id ="ghi_chu"
                                    value={obj.ghi_chu}
                                    onChange={(e) => onChangeInput( e)}
                                />
                            </div>
                            { !isAddMode && filterTrangthais.length > 0 && (
                                <div className="col-md-6">
                                    <TrangthaiListComponent trangthai_fk = {obj.trangthai_fk}
                                                            onChange ={(opt, e) => {
                                                                const target = {name: "trangthai_fk", value: opt?.value};
                                                                onChangeInput({target})}}
                                                            /*filterIds = { [0,1] }*/
                                                            filterIds={filterTrangthais}
                                                            trangthaiName = "so_name"
                                                            disabled={obj1.trangthai_fk === 7 || obj1.trangthai_fk === 8}
                                    />

                                </div>
                            ) }
                            <div className="col-md-6">
                                <GuikemListComponent
                                                    disable={obj1.trangthai_fk != 0}
                                                    name='guikem_fks'
                                                     labelName='Gửi kèm'
                                                     isMulti ={true}
                                                     value={obj.guikem_fks}
                                                     onChange={(opt) => onChangeInput({ target: { name: "guikem_fks", value: opt } })} />
                            </div>
                        </div>

                        <hr/>
                        <div className="row table-responsive">
                            <div className="col-md-12">
                                <table responsive bordered hover
                                       className="table table-bordered table-hover text-nowrap">
                                    <thead>
                                    <tr>
                                        <th className="col-md-1 text-center">Mã</th>
                                        <th className="col-md-1 text-center">Tên</th>
                                        <th className="col-md-1 text-center">Đơn vị tính</th>
                                        <th className="col-md-1 text-center">Số lượng</th>
                                        <th className="col-md-1 text-center">Chỉ định</th>
                                        <th className="col-md-1 text-center">Tác vụ</th>
                                    </tr>
                                    </thead>
                                    <tbody>

                                    {
                                       obj && obj.sanpham && obj.sanpham.map((item, index) => {
                                           item.is_rang

                                           let editable = [];
                                           if(item.is_rang ===1 && (isAddMode === 0 || obj.trangthai_fk === 0))
                                           {
                                               editable = [
                                                   ...editable,
                                                   <a
                                                       className="btn btn-danger btn-sm mr-2"
                                                       key={`delete-donhangcls-${index}`}
                                                       title={t('action.label.delete')}
                                                       onClick={() => {
                                                           if (
                                                               window.confirm('Xóa dòng sản phẩm')
                                                           )
                                                               deletesanpham(index);
                                                       }}>
                                                       <i className="fas fa-trash" />
                                                   </a>,
                                               ];
                                           }

                                           if(item.is_rang ===1 && (isAddMode === 0 || obj.trangthai_fk === 0))
                                           {
                                               editable = [
                                                   ...editable,
                                                   <a
                                                       className="btn btn-info btn-sm mr-2"
                                                       key={`delete-donhangcls-${index}`}
                                                       title={t('action.label.delete')}
                                                       onClick={() => {

                                                           openRanglienket(item,index);
                                                       }}>
                                                       <i className="fas fa-pencil-alt" />
                                                   </a>,
                                               ];
                                           }

                                            return (
                                                <tr>
                                                    <td className="text-center">
                                                        <input className="text-left form-control"  type="text" id={`ma-${index}`}
                                                               value={item.ma}

                                                        />
                                                    </td>
                                                    <td className="text-center">
                                                        <input className="text-left form-control" type="text" id={`ten-${index}`}
                                                               value={item.ten}

                                                        />
                                                    </td>
                                                    <td className="text-center">
                                                        <input className="text-center form-control" type="text" id={`don_vi_tinh-${index}`}
                                                               value={item.don_vi_tinh}

                                                        />
                                                    </td>
                                                    <td className="text-center" >
                                                        <input className="text-right form-control"  type="number" id={`so_luong-${index}`}
                                                               name={`so_luong-${index}`}
                                                               value={item.so_luong}
                                                               readOnly ={item.is_rang ===1 || obj.trangthai_fk != 0}
                                                               onChange={(e) => handleChange_Soluong(index, Number(e.target.value))}
                                                        />
                                                    </td>
                                                    <td className="text-center">
                                                        <input className="text-left form-control" type="text" id={`ten-${index}`}
                                                               value={item.chi_dinh}

                                                        />
                                                    </td>
                                                    <td className="text-center">
                                                        { editable  }
                                                    </td>


                                                </tr>
                                            );


                                        })

                                    }
                                    <tr>
                                        { (isAddMode || obj.trangthai_fk === 0)  && (
                                            <td className="text-center" colSpan="2">
                                                <SanphamAutocompleteComponent
                                                    path_access={currController}
                                                    onChange={(e) => onChangeInput({ target: { name: 'sanpham', value: e?.value } })}
                                                />
                                            </td>
                                        )}

                                        <td className="text-center">

                                        </td>
                                        <td className="text-center">

                                        </td>
                                        <td className="text-center">

                                        </td>

                                    </tr>
                                    </tbody>



                                </table>
                            </div>


                        {/*<div className="row">
                            <div className="col-md-12">
                                <label>Ghi chú</label>
                                <textarea rows="2" maxLength="500" className="form-control" name="ghi_chu" id="ghi_chu" value={obj.ghi_chu} onChange={onChangeInput} />
                            </div>
                        </div>*/}
                    </div>
                        </div>
                </div>
            </div>

            <div className="card-footer" >

                <Modal size="lg" show={showModal} onHide={() => { setShowModal(false)}}>
                    <Modal.Header>
                        <Modal.Title>
                            Răng liên kết
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className='form-group row'>
                            <div className="col-md-3">
                                <RanglienketComponent
                                    from_to='from'
                                    labelName= 'Vị trí răng'
                                    required="required"
                                    name='ranglienket1_fk'
                                    labelName='Vị trí răng'
                                    value={obj.ranglienket1_fk}
                                    onChange={(opt) => onChangeInput({ target: { name: "ranglienket1_fk", value: opt } })} />
                            </div>

                            {
                                obj.ranglienket1_fk &&
                                (
                                    <div className="col-md-3">
                                    <RanglienketComponent
                                        labelName= 'Vị trí răng liên kết'
                                        name='ranglienket2_fk'
                                        ranglienket_fk = {obj.ranglienket1_fk?.value}
                                        from_to='to'
                                        value={obj.ranglienket2_fk}
                                        onChange={(opt) => onChangeInput({ target: { name: "ranglienket2_fk", value: opt } })} />
                                    </div>
                                    )

                            }

                            <div className="col-md-3">
                                <label >Số răng</label>
                                <input
                                    type='text'
                                    className="form-control"
                                    name="tong_so_rang"
                                    id ="tong_so_rang"
                                    value={obj.tong_so_rang}
                                />

                            </div>
                            <div className="col-md-3">
                                <Button
                                    className="btn  btn-success  mr-1"
                                    icon="right fas fa-angle-left"
                                    onClick={addRang}
                                >
                                    <i className="fa fa-plus">Thêm</i>
                                </Button>
                            </div>
                        </div>

                        <hr/>
                        {
                            sanphamModal && sanphamModal.ranglienket_fks && sanphamModal.ranglienket_fks.map((item2, index2) => {

                                // let labelName = '';
                                // if(item2.ranglienket2_fk)
                                // {
                                //     labelName = item2.ranglienket1_fk.label +' -> ' + item2.ranglienket2_fk.label
                                // }
                                // else
                                //     labelName = item2.ranglienket1_fk.label;

                                return ( <div className='form-group row'>
                                        <div className="col-md-4">
                                            <input
                                                type='text'
                                                className="form-control"
                                                value={item2.labelname}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <input
                                                type='text'
                                                className="form-control"
                                                value={item2.so_luong}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <a
                                                className="btn btn-danger btn-sm mr-2"
                                                key={`delete-donhangcls-${index2}`}
                                                title={t('action.label.delete')}
                                                onClick={() => {
                                                    if (
                                                        window.confirm('Xóa dòng răng đã chọn?')
                                                    )
                                                        deleterang(index2);
                                                }}>
                                                <i className="fas fa-trash" />
                                            </a>
                                        </div>
                                    </div>
                                );
                            })
                        }
                        <hr/>
                        <div className='form-group row'>
                            <div className="col-md-8">
                            </div>
                            <div className="col-md-4">
                                <label >Tổng số răng</label>
                                <input
                                    type='text'
                                    className="form-control text-right"
                                    value={sanphamModal.so_luong}
                                />

                            </div>

                        </div>


                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => {setShowModal(false); }}>
                            {"Thoát"}
                        </Button>



                    </Modal.Footer>
                </Modal>


            </div>


        </div>
    );
}

export {DonhangEdit};
